<template>
  <div class="elite-tabs-wrapper-content">
    <h3 class="mb-4">{{ client.name }}</h3>
    <div class="resume-list">
      <div class="resume-list-inner">
        <dl class="width_1-2">
          <dt>{{ $t("COMMON.NAME") }}</dt>
          <dd>
            {{ client.name }}
          </dd>
        </dl>
        <dl class="width_1-2">
          <dt>{{ $t("COMMON.REDIRECT_URL") }}</dt>
          <dd>
            {{ client.redirect }}
          </dd>
        </dl>

        <dl class="width_1-2">
          <dt>{{ $t("COMMON.CREATED_AT") }}</dt>
          <dd v-if="client.createdAt">
            {{ $timeZoneDateFormat(client.createdAt) }}
          </dd>
        </dl>
        <dl class="row">
          <dt>{{ $t("COMMON.UPDATED_AT") }}</dt>
          <dd v-if="client.updatedAt">
            {{ $timeZoneDateFormat(client.updatedAt) }}
          </dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import Users from "@/components/Users.vue";
import Contacts from "@/components/Contacts.vue";

export default {
  name: "client-view-global",

  components: {
    Users,
    Contacts,
  },

  props: ["client"],

  data() {
    return {};
  },

  computed: {},

  created() {},

  methods: {},

  mounted() {},

  watch: {
    client(client) {},
  },
};
</script>
